export default "__VITE_ASSET__Dmpgbhzv__"